/* eslint-disable no-return-assign */

export const cleanURI = (token: any): any => {
  if (!token) {
    return (window.location.href = '/login');
  }
  return token?.replace("'", '');
};

export const decodeToken = (rememberToken: any): any => {
  const base64Url = rememberToken.split('.')[1];
  const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join(''),
  );
  return JSON.parse(jsonPayload);
};

export const verifyTokenIsValid = (tokenDecoded: any): any => {
  if (tokenDecoded.exp < Date.now() / 1000) {
    return true;
  }
  return false;
};
